import React from "react";
import zoomSdk from "@zoom/appssdk";
import Box from "@amzn/meridian/esm/components/box";
import Card from "@amzn/meridian/esm/components/card";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import wikiIcon from "../../images/wiki_icon.svg";
import LogManager from "../utils/LogManager";

const WikiCard = () => {
  const handleWikiClick = async () => {
    console.log("Trying open AIMS wiki...");
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Card width="272px" onClick={handleWikiClick} spacingInset="none">
      <Row spacing="none">
        <Row width="16px" />
        <Column spacing="none" spacingInset="none">
          <Column height="20px" />
          <img src={wikiIcon} alt="wikiIcon" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
          <Column height="20px" />
        </Column>
        <Row width="16px" />
        <Box spacingInset="none" width="168px">
          <Column spacing="none" spacingInset="none">
            <Column height="16px" />
            <Text fontFamily="amazonEmber" type="h100" alignment="start">
              Wiki
            </Text>
            <Column height="8px" />
            <Text fontFamily="amazonEmber" type="b100" color="secondary" alignment="start">
              Learn about Amazon Meetings Summary
            </Text>
            <Column height="20px" />
          </Column>
        </Box>
      </Row>
    </Card>
  );
};

export default WikiCard;
